import React, { useState } from "react";
import Login from "./Login";
import "../App.css";
import "./AuthModal.css";

import Modal from "react-bootstrap/Modal";
import Accordion from "react-bootstrap/Accordion";

import logoLight from "../assets/logo.svg";
import logoDark from "../assets/logo-dark.svg";
import promoList1 from "../assets/home-advantage-1.svg";
import promoList2 from "../assets/home-advantage-2.svg";
import promoList3 from "../assets/home-advantage-3.svg";
import promoList4 from "../assets/home-advantage-4.svg";

import { useAuth } from "../contexts/AuthContext";
import LoginPhone from "./LoginPhone";

// Sign-up is closed while the product is in testing; only allowlisted members can log in.
function MembersOnlyNotice({ onContinue }) {
  return (
    <div className="auth-members-only">
      <h3>Members-only access</h3>
      <p>
        FnO Bazar is in testing, so we've paused new sign-ups. Only authorised members can log in for now.
      </p>
      <p>If you're an authorised member, continue to log in.</p>
      <button className="auth-members-only-continue" onClick={onContinue}>
        Continue to log in
      </button>
    </div>
  );
}

export default function AuthModal(props) {
  const [acknowledged, setAcknowledged] = useState(false);
  const { accessError, clearAccessError } = useAuth();
  const [activeKey, setActiveKey] = useState("0");
  const handleAccordionChange = (eventKey) => {
    // Ensure at least one accordion item is always open
    const isOpen = activeKey === eventKey;
    // console.log(isOpen, eventKey, activeKey)
    // Get all the open accordion items
    const openItems = isOpen ? [] : [eventKey];
    // console.log(openItems,activeKey)
    // Ensure that there is at least one accordion item open
    if (
      openItems.length > 0 ||
      (openItems.length === 0 && activeKey !== null)
    ) {
      if (openItems[0] === null) {
        setActiveKey(!activeKey);
      } else {
        setActiveKey(openItems);
      }
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={() => {
        props.setAuthModalIsOpen(false);
        setAcknowledged(false);
        clearAccessError();
      }}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Body className="bootstrap-modal-body-wrapper">
        <div className="auth-modal-content">
          <div className="auth-modal-promo" data-theme={props.theme}>
            <div className="auth-modal-promo-title-container">
              <h3>Get Started with</h3>
              <img
                src={props.theme === "light" ? logoDark : logoLight}
                alt="fno bazaar"
              />
              <h3>for</h3>
            </div>
            <div className="auth-modal-promo-list" data-theme={props.theme}>
              <p className="auth-modal-promo-list-item">
                <img src={promoList1} alt="comprehensive market research" />
                <span>Comprehensive Market Research</span>
              </p>
              <p className="auth-modal-promo-list-item">
                <img src={promoList2} alt="24 7 support" />
                <span>24/7 Support</span>
              </p>
              <p className="auth-modal-promo-list-item">
                <img src={promoList3} alt="realtime data" />
                <span>Real-Time Data</span>
              </p>
              <p className="auth-modal-promo-list-item">
                <img src={promoList4} alt="mobile accessibiility" />
                <span>Mobile Accessibility</span>
              </p>
            </div>
          </div>
          <div className="auth-modal-auth-container" data-theme={props.theme}>
            {!acknowledged && !accessError ? (
              <MembersOnlyNotice onContinue={() => setAcknowledged(true)} />
            ) : (
            <>
            <h3>Log in</h3>
            {accessError && (
              <p className="auth-access-error" role="alert">
                {accessError}
              </p>
            )}
            <div className="auth-accordion-container">
              <Accordion
                defaultActiveKey="0"
                activeKey={activeKey}
                onSelect={handleAccordionChange}
                data-theme={props.theme}
              >
                <Accordion.Item eventKey="0">
                  <Accordion.Header data-theme={props.theme}>
                    Login with Email and Password
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="auth-modal-form-container">
                      <Login theme={props.theme} />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header data-theme={props.theme}>
                    Login with Phone Number
                  </Accordion.Header>
                  <Accordion.Body>
                    <LoginPhone theme={props.theme} />
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
            </>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
